export default [
  { path: '/', name: 'home', meta: { needMe: true }, component: () => import('@/views/Statistics.vue') }
]
